import { useTourV2 } from 'core/tour-v2/TourProvider';

export const useAnyActiveTourStepId = () => useTourV2().currentStepId;
